import {useEffect, useRef, useState} from 'react';
import {
    ActivityIndicator,
    AlertModal,
    CCText,
    Modal,
    View
} from '../../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import AppConfig from '../../../../AppConfig';

import DefaultButton, {
    BorderlessButton,
    DarkButton, ReturnButton,
    ThemeButton
} from '../../../../custom-packages/react-button-package/ButtonPackage';

import * as MaskFunctions from '@chocostack/maskifier';

import NewFoodModal from "../../../../components/admin/Food/NewFoodModal";
import Styles from "../../../../Styles";

import CheckMarkIcon from "../../../../assets/custom-icons/CheckMarkIcon";
import FoodPricing from "../../../../components/admin/Food/FoodPricing";
import FoodImage from "../../../../components/admin/Food/FoodImage";
import {GetAuthObject} from "../../../../authentication/AuthFunctions";
import MenuSection from "../../../../models/menu/MenuSection";
import Food from "../../../../models/menu/Food";
import FoodPrice from "../../../../models/menu/FoodPrice";
import {useNavigate, useParams} from "react-router-dom";
import DropdownMenu from "../../../../custom-packages/dropdown-menu/DropdownMenu";
import GearIcon from "../../../../assets/custom-icons/GearIcon";
import MenuEditorTopBar from "./Components/MenuEditorTopBar";
import MenuEditorBottomBar from "./Components/MenuEditorBottomBar";
import {RegisterEvent} from "../../../../AnalyticsFunctions";
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';

const TMenuCategoryScreen = {
    // English
    "enUS": {
        'NEW_FOOD': 'Create Food',
        'ADD_FOOD': 'Search',
        'DELETE_FOOD': 'Remove Food',
        'DELETE_FOOD_TEXT': 'Do you wish to remove this food from your menu?',
        'CANCEL': 'Cancel',
        'REMOVE': 'Remove',
        'REMOVED': 'Removed',
        'IMAGE': 'Image',
        'PRICES': 'Prices',
        'ITEMS_ADDED': ' items already added to the menu',
        'PERSON_IN_CHARGE': 'Person in charge',
        'PERSON_IN_CHARGE_DESC': 'Food in this section will go to this role directly when an order is created',
        'PRESS_TO_CHANGE': '(PRESS TO CHANGE)',
        'SECTIONS': 'Sections',
        'SELECT_FOOD': 'Edit List',
        'SEARCH_FOOD': 'Search Existing Food',
        'SEARCH_FOOD_DESC': 'Search existing food or create a new item to add to the menu',
        'REMOVE_FOOD': 'Remove',
        'REMOVE_PRICE': 'Remove',
        'ADD': 'Add',
        'ADD_ALL': 'Add All',
        'CREATE_AND_ADD': 'CREATE AND ADD ',
        'ADD_PRICES': 'Add Prices',
        'OR_CREATE_FOOD': 'or you can',
        'NO_PRICES': 'There are no prices to add',
        'NEW_PRICE': 'New Price',
        'RETURN': 'Return',
        'NO_FOOD': 'No food have been added yet',
        'UNEXPECTED_ERROR_REORDER': 'The items couldn\'t be reordered, try again later',
        'DRAG_AND_DROP': 'Drag and drop an item to reorder it',
    },
    // Spanish
    "esMX": {
        'ITEMS_ADDED': ' alimentos agregados al menú',
        'PERSON_IN_CHARGE': 'Encargado',
        'PERSON_IN_CHARGE_DESC': 'La comida de esta sección será enviada al rol encargado cuando una orden sea creada',
        'PRESS_TO_CHANGE': '(PRESIONA PARA CAMBIAR)',
        'SECTIONS': 'Secciones',
        'SELECT_FOOD': 'Editar Lista',
        'SEARCH_FOOD': 'Buscar Alimentos Existentes',
        'SEARCH_FOOD_DESC': 'Busca alimentos existentes o crea uno nuevo para agregar al menú',
        'REMOVE_FOOD': 'Quitar',
        'REMOVE_PRICE': 'Quitar',
        'REMOVE': 'Quitar',
        'ADD': 'Agregar',
        'ADD_ALL': 'Agregar Todos',
        'CREATE_AND_ADD': 'CREAR Y AGREGAR ',
        'ADD_PRICES': 'Agregar Precios',
        'OR_CREATE_FOOD': 'o puedes',
        'NO_PRICES': 'No hay mas precios que agregar',
        'NEW_PRICE': 'Nuevo Precio',
        'NEW_FOOD': 'Crear Alimento',
        'ADD_FOOD': 'Buscar',
        'DELETE_FOOD': 'Remover Alimento',
        'DELETE_FOOD_TEXT': 'Deseas remover este alimento de tu menú?',
        'CANCEL': 'Cancelar',
        'REMOVED': 'Removido',
        'IMAGE': 'Imagen',
        'PRICES': 'Precios',
        'RETURN': 'Regresar',
        'NO_FOOD': 'No se han agregado alimentos, intenta crear uno nuevo',
        'UNEXPECTED_ERROR_REORDER': 'Los alimentos no pudieron reordenarse, intenta de nuevo más tarde.',
        'DRAG_AND_DROP': 'Manten presionado un alimento y arastralo para reordenarlo',
    }
}

const MenuCategoryScreen = (props) => {
    const auth = GetAuthObject();
    const navigate = useNavigate()
    const msgTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const params = useParams()
    const id = params.id;

    const [totalItems, setTotalItems] = useState(props.totalItems);
    const [loading, setLoading] = useState(true);
    const [section, setSection] = useState<MenuSection | null>(null)
    const [foodValue, setFoodValue] = useState('');
    const [isNewFoodModalOpen, setIsNewFoodModalOpen] = useState(false);
    const [isSearchFoodModalOpen, setIsSearchFoodModalOpen] = useState(false);
    const [alertData, setAlertData] = useState({
        visible: false,
        title: '',
        text: '',
        buttons: []
    });

    const [saving, setSaving] = useState<boolean>(false)
    const [saved, setSaved] = useState<boolean>(false)
    const [errorMsg, setErrorMsg] = useState<string>('')

    useEffect(() => {
        const f = async () => {
            setLoading(true)

            const response = await fetch(AppConfig.URL + "/Menu/FetchMenuSection/" + id, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                },
            });

            var json = await response.json();

            setSection(json.section)
            setLoading(false)
        }

        f()
    }, [id])

    if (loading)
        return <View style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start'}}>
            <MenuEditorTopBar
                menuID={id}
            />
            <View style={{height: 70}}></View>
            <ActivityIndicator style={{marginTop: 170}}/>
        </View>

    if (!section)
        return <View>
            Category doesn't exists
        </View>

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        // Clear the existing timeout if there is one
        if (msgTimeoutRef.current) {
            clearTimeout(msgTimeoutRef.current);
        }

        setSaving(true)
        setSaved(false)
        setErrorMsg('')

        const itemsToOrder = new Array<any>()

        const updatedItems = Array.from(section.food);
        const [movedItem] = updatedItems.splice(result.source.index, 1);
        updatedItems.splice(result.destination.index, 0, movedItem);

        // Update the order of each item based on its new position
        updatedItems.forEach((item, index) => {
            item.order = index + 1; // Assuming pqu_order is 1-based

            item.prices.forEach(price => {
                itemsToOrder.push({
                    order: item.order, // This order number will be used to order per food, for the MIT_FOOD_ORDER field
                    id: price.fpr_id
                })
            })
        });


        const updatedSection = {...section}

        updatedSection.food = updatedItems;

        setSection(updatedSection);

        const reorderRequest = async () => {
            try {

                const response = await fetch(AppConfig.URL + "/Menu/ReorderMenuItems/", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': auth.token
                    },
                    body: JSON.stringify(itemsToOrder)
                });

                const json = await response.json();

                if(json.success){
                    setSaved(true)
                } else {
                    setErrorMsg(TMenuCategoryScreen[AppConfig.lang].UNEXPECTED_ERROR_REORDER)
                }

            } catch (ex) {
                console.log(ex)

                setErrorMsg(TMenuCategoryScreen[AppConfig.lang].UNEXPECTED_ERROR_REORDER)
            }

            setSaving(false)

            // Set a new timeout
            msgTimeoutRef.current = setTimeout(() => {
                setSaved(false)
                setErrorMsg('')
            }, 5000);
        }

        reorderRequest()
    };

    const toggleMenuItem = async (price, foodID) => {
        const response = await fetch(AppConfig.URL + "/Menu/ToggleMenuItem/?foodID=" + foodID, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': auth.token
            },
            body: JSON.stringify({
                MIT_FOOD_PRICE_ID: price.fpr_id,
                MIT_MENU_SECTION_ID: section.mse_id,
            })
        });

        const json = await response.json();

        return json;
    }

    return <View>
        <MenuEditorTopBar
            menuID={section.mse_menu_id}
        />
        <MenuEditorBottomBar
            menuID={section.mse_menu_id}
            saving={saving}
            saved={saved}
            errorMsg={errorMsg}
        />
        <View style={{height: 40}}></View>
        <View
            style={{padding: '15px 0'}}
        >
            <View
                className={'row'}
            >
                <View className={'col-lg-3'}></View>
                <View
                    className={'col-lg-6'}
                >
                    <View
                        style={{
                            flexDirection: 'row'
                        }}
                    >
                        <ReturnButton
                            text={TMenuCategoryScreen[AppConfig.lang].RETURN}
                            onPress={() => {
                                navigate(-1)
                            }}
                        />
                    </View>
                    <View
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <h1
                            style={{marginBottom: 0}}
                        >
                            {section.mse_name}
                        </h1>
                        {
                            !auth.sub ?
                                null
                                :
                                <View style={{flexDirection: 'row'}}>
                                    <ThemeButton
                                        text={TMenuCategoryScreen[AppConfig.lang].NEW_FOOD}
                                        onPress={() => {
                                            RegisterEvent({
                                                source: window.location.href,
                                                sequenceID: AppConfig.ANALYTICS_SEQUENCE_MENU_CREATOR,
                                                token: auth.token,
                                                action: 'BUTTON_ADD_FOOD_CLICK'
                                            })

                                            setIsNewFoodModalOpen(!isNewFoodModalOpen)
                                        }}
                                    />
                                    {
                                        false ?
                                            <View>
                                                <View style={{width: 10}}></View>
                                                <DefaultButton
                                                    text={TMenuCategoryScreen[AppConfig.lang].ADD_FOOD}
                                                    onPress={() => {
                                                        setIsSearchFoodModalOpen(!isSearchFoodModalOpen)
                                                    }}
                                                />
                                            </View>
                                            :
                                            null
                                    }
                                </View>
                        }
                    </View>
                    <CCText>
                        {section.mse_description}
                    </CCText>
                </View>
                <View className={'col-lg-3'}></View>
            </View>
        </View>
        <View
            className={'row'}
        >
            <View className={'col-lg-3'}></View>
            <View
                className={'col-lg-6'}
            >
                {
                    !section.food || section.food.length == 0 ?
                        <View
                            className={'col-12'}
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'center',
                                paddingTop: 30
                            }}
                        >
                            <CCText
                                style={{
                                    fontSize: '1.5rem',
                                    color: 'gray',
                                    textAlign: 'center'
                                }}
                            >
                                {TMenuCategoryScreen[AppConfig.lang].NO_FOOD}
                            </CCText>
                        </View>
                        :
                        null
                }{
                section.food && section.food.length >= 2 ?
                    <CCText
                        className={'alert alert-info'}
                        style={{
                            textAlign: 'center',
                            margin: 0
                        }}
                    >
                        {TMenuCategoryScreen[AppConfig.lang].DRAG_AND_DROP}
                    </CCText>
                    :
                    null
            }
                <DragDropContext
                    onDragEnd={handleOnDragEnd}
                    sensorOptions={{
                        touch: {
                            longPressTime: 500, // Increase this value to make the long press duration longer
                        },
                    }}
                >
                    <Droppable
                        droppableId="droppable-list"
                    >
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className={''}
                            >
                                {section.food.map((food, index) =>
                                    <Draggable
                                        key={food.foo_id}
                                        draggableId={food.foo_id}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <FoodItem
                                                    key={food.foo_id}
                                                    item={food}
                                                    menuSection={section}
                                                    toggleMenuItem={toggleMenuItem}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                )}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </View>
            <View className={'col-lg-3'}></View>
        </View>
        <View style={{height: 175}}></View>
        <NewFoodModal
            initialName={foodValue}
            visible={isNewFoodModalOpen}
            onRequestClose={() => setIsNewFoodModalOpen(!isNewFoodModalOpen)}
            callback={async (newFood) => {
                setIsNewFoodModalOpen(false)
                setFoodValue('')

                for (let i = 0; i < newFood.prices.length; i++) {
                    await toggleMenuItem(newFood.prices[i], newFood.foo_id);
                }

                const updatedSection = {...section}
                const updatedFood = [...updatedSection.food]

                updatedFood.push(newFood)
                updatedSection.food = updatedFood

                setSection(updatedSection)
                setTotalItems(totalItems + 1)
            }}
        />
        <SearchFoodModal
            visible={isSearchFoodModalOpen}
            onRequestClose={() => setIsSearchFoodModalOpen(!isSearchFoodModalOpen)}
            title={TMenuCategoryScreen[AppConfig.lang].SEARCH_FOOD}
            description={TMenuCategoryScreen[AppConfig.lang].SEARCH_FOOD_DESC}
            enableNewItemButton={true}
            menuSection={section}
            updateSection={(section) => {
                setSection(section);
            }}
            toggleMenuItem={toggleMenuItem}
            onNewItemPressed={(value) => {
                setFoodValue(value)
                setIsSearchFoodModalOpen(!isSearchFoodModalOpen)

                setTimeout(() => {
                    setIsNewFoodModalOpen(!isNewFoodModalOpen)
                }, 30)
            }}
            setTotalItems={(number) => {
                setTotalItems(totalItems + number)
            }}
        />
        <AlertModal
            visible={alertData.visible}
            onRequestClose={() => {
                const alertDataCopy = {...alertData}

                alertDataCopy.visible = !alertDataCopy.visible

                setAlertData(alertDataCopy)
            }}
            title={alertData.title}
            text={alertData.text}
            buttons={alertData.buttons}
        />
    </View>;
}

export default MenuCategoryScreen;

const FoodItem = ({item, menuSection, toggleMenuItem}) => {
    const [food, setFood] = useState<Food>(item)
    const [removing, setRemoving] = useState<boolean>(false)
    const [removed, setRemoved] = useState<boolean>(false)
    const [isAddPricesModalOpen, setIsAddPricesModalOpen] = useState<boolean>(false);
    const [alertData, setAlertData] = useState<any>({
        visible: false,
        title: '',
        text: '',
        buttons: []
    });

    const removeFood = (food) => {
        setAlertData({
            visible: !alertData.visible,
            title: TMenuCategoryScreen[AppConfig.lang].DELETE_FOOD,
            text: TMenuCategoryScreen[AppConfig.lang].DELETE_FOOD_TEXT + ' (' + food.foo_name + ')',
            buttons: [
                {
                    text: TMenuCategoryScreen[AppConfig.lang].CANCEL,
                    onPress: () => {
                    },
                    style: "cancel"
                },
                {
                    text: TMenuCategoryScreen[AppConfig.lang].REMOVE,
                    onPress: async () => {
                        setRemoving(true)

                        const prices = [...food.prices]

                        for (let i = 0; i < prices.length; i++) {
                            await toggleMenuItem(prices[i], food.foo_id)
                        }

                        setRemoved(true)
                        setRemoving(false)
                    }
                }
            ]
        })
    }

    if (removed)
        return <View className={'col-12'}>
            <View
                style={{
                    marginTop: 15,
                }}
                className={'card'}
            >
                <View
                    className={'card-body'}
                >
                    <i><strong>{TMenuCategoryScreen[AppConfig.lang].REMOVED}</strong></i>
                </View>
            </View>
        </View>

    return <View className={'col-lg-12'}>
        <View
            style={{
                marginTop: 15,
                overflow: 'initial'
            }}
            className={'card'}
        >
            <View className={'card-body'}>
                <View>
                    <View
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <CCText style={{fontSize: '1.5rem', fontWeight: 'bold'}}>
                            {food.foo_name}
                        </CCText>
                        {removing ?
                            <ActivityIndicator/>
                            :
                            <DropdownMenu
                                buttonText={<GearIcon/>}
                                options={[
                                    {
                                        text: TMenuCategoryScreen[AppConfig.lang].ADD_PRICES,
                                        onPress: () => {
                                            setIsAddPricesModalOpen(true)
                                        }
                                    },
                                    {
                                        textStyle: Styles.redColor,
                                        text: TMenuCategoryScreen[AppConfig.lang].REMOVE_FOOD,
                                        onPress: () => {
                                            removeFood(food)
                                        }
                                    }
                                ]}
                            />
                        }
                    </View>
                    <CCText style={{fontSize: '1.2rem'}}>
                        {food.foo_description}
                    </CCText>
                </View>
                <View
                    style={{
                        marginTop: 15,
                        flexDirection: 'row',
                        justifyContent: 'flex-start'
                    }}
                >
                    <View>
                        <FoodImage
                            style={{
                                marginRight: 15,
                            }}
                            imageStyle={{
                                width: 75,
                                height: 75,
                            }}
                            foodID={food.foo_id}
                            imageLq={food.foo_image_lq}
                            onImageChanged={(image) => {
                                const foodCopy = {...food}

                                food.foo_image = image;
                                food.foo_image_lq = image;

                                setFood(foodCopy)
                            }}
                        />
                    </View>
                    <View>
                        <CCText
                            style={{
                                fontWeight: 'bold'
                            }}
                        >
                            {TMenuCategoryScreen[AppConfig.lang].PRICES}
                        </CCText>
                        {
                            food.prices ?
                                food.prices.length == 1 ?
                                    <CCText
                                        style={{
                                            color: Styles.themeSecondaryColor.color,
                                            fontWeight: 'bold',
                                            whiteSpace: 'nowrap'
                                        }}>
                                        {MaskFunctions.maskMoney(food.prices[0].fpr_price) + ' ' + food.prices[0].fpr_currency}
                                    </CCText>
                                    :
                                    <View>
                                        <ul>
                                            {
                                                food.prices.map(p => <li>
                                                    <CCText style={{fontSize: 18}}>
                                                        {p.fpr_title + ':'}
                                                    </CCText>
                                                    <View
                                                        style={{
                                                            flexDirection: 'row',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <CCText style={{
                                                            marginLeft: 7,
                                                            color: Styles.themeSecondaryColor.color,
                                                            fontWeight: 'bold',
                                                            whiteSpace: 'nowrap'
                                                        }}>
                                                            {MaskFunctions.maskMoney(p.fpr_price) + ' ' + p.fpr_currency}
                                                        </CCText>
                                                        {
                                                            p.toggling ?
                                                                <ActivityIndicator style={{marginLeft: 15}} size={20}/>
                                                                :
                                                                <CCText
                                                                    className={'clickable'}
                                                                    style={{marginLeft: 15, ...Styles.redColor}}
                                                                    onPress={async () => {
                                                                        const foodCopy = {...food}

                                                                        const priceIndex = foodCopy.prices.findIndex(i => i.fpr_id === p.fpr_id)
                                                                        const json = await toggleMenuItem(p, foodCopy.foo_id)

                                                                        if (json.success) {
                                                                            food.prices.splice(priceIndex, 1)
                                                                        } else {
                                                                            food.prices[priceIndex].toggling = false;
                                                                        }

                                                                        setFood(foodCopy)
                                                                    }}
                                                                >
                                                                    {
                                                                        TMenuCategoryScreen[AppConfig.lang].REMOVE_PRICE
                                                                    }
                                                                </CCText>
                                                        }
                                                    </View>
                                                </li>)
                                            }
                                        </ul>
                                    </View>
                                :
                                null
                        }
                    </View>
                </View>
                <View
                    style={{flexDirection: 'row', justifyContent: 'flex-end'}}
                >
                    <AddPricesModal
                        food={food}
                        menuSection={menuSection}
                        visible={isAddPricesModalOpen}
                        onRequestClose={() => {
                            setIsAddPricesModalOpen(false)
                        }}
                        toggleMenuItem={toggleMenuItem}
                        updateFood={(food) => setFood(food)}
                    />
                    <AlertModal
                        visible={alertData.visible}
                        onRequestClose={() => {
                            const alertDataCopy = {...alertData}

                            alertDataCopy.visible = !alertDataCopy.visible

                            setAlertData(alertDataCopy)
                        }}
                        title={alertData.title}
                        text={alertData.text}
                        buttons={alertData.buttons}
                    />
                </View>
            </View>
        </View>
    </View>
}

const SearchFoodModal = (props) => {
    const auth = GetAuthObject();
    const timerRef = useRef(null);
    const className = props.className ? props.className : 'form-control';
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<Array<Food>>([])
    const [inputValue, setInputValue] = useState<string>('')
    const [limitReached, setLimitReached] = useState<boolean>(false)


    const handleItemSelect = async (selectedOption) => {
        for (let i = 0; i < selectedOption.prices.length; i++) {
            if (!selectedOption.prices[i].added) {
                const json = await props.toggleMenuItem(selectedOption.prices[i], selectedOption.foo_id);

                if (!json.success) {
                    if (json.limitReached) {
                        setLimitReached(json.limitReached)
                    }
                }
            }
        }

        const updatedSection = {...props.menuSection}
        const updatedFood = [...updatedSection.food]

        const index = updatedFood.findIndex(i => i.foo_id === selectedOption.foo_id)

        if (index == -1) {
            updatedFood.push(selectedOption)

            props.setTotalItems(1);
        } else
            updatedFood[index] = selectedOption

        updatedSection.food = updatedFood

        props.updateSection(updatedSection)
    };


    useEffect(() => {
        if (timerRef.current)
            clearTimeout(timerRef.current);

        if (!inputValue) {
            setData([]);
            return;
        }

        // @ts-ignore
        timerRef.current = setTimeout(async () => {
            const response = await fetch(AppConfig.URL + "/Menu/FetchSelectableFood/?Search=" + inputValue + "&MenuSectionID=" + props.menuSection.mse_id + '&ExcludeSelected=true', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                }
            });

            const json = await response.json();

            if (props.getData)
                props.getData(json.food);

            setData(json.food);
            setLoading(false);
        }, 500);
    }, [inputValue])

    return <Modal
        visible={props.visible}
        onRequestClose={props.onRequestClose}
    >
        <h2>
            {props.title}
        </h2>
        <div style={{marginBottom: 15}}>
            {props.description}
        </div>
        {
            limitReached ?
                <div className={'alert alert-warning'}
                     dangerouslySetInnerHTML={{__html: TMenuCategoryScreen[AppConfig.lang].ITEM_LIMIT_REACHED}}>

                </div>
                :
                <div>
                    <input
                        type={props.type ? props.type : 'text'}
                        value={props.value}
                        onChange={async (event) => {
                            setLoading(true)

                            // @ts-ignore
                            setInputValue(event.target.value)

                            if (props.onChange)
                                await props.onChange(event);
                        }}
                        placeholder={TMenuCategoryScreen[AppConfig.lang].SEARCH_FOOD}
                        className={className}
                        style={{fontSize: 20, ...props.style}}
                    />
                    <div style={{minHeight: 300}}>
                        <div>
                            {inputValue && (props.loading || loading) ?
                                <div style={{
                                    height: 100,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <ActivityIndicator/>
                                </div>
                                :
                                <div>
                                    {
                                        data.length > 0 ?
                                            data.map(item => {
                                                return <div>
                                                    <div
                                                        style={{padding: '20px 0'}}
                                                    >
                                                        <View style={{
                                                            flexDirection: 'row',
                                                            justifyContent: 'space-between'
                                                        }}>
                                                            <CCText style={{fontWeight: 'bold'}}>
                                                                {item.foo_name}
                                                            </CCText>
                                                            {
                                                                item.toggling ?
                                                                    <ActivityIndicator size={20}/>
                                                                    :
                                                                    item.added ?
                                                                        <CheckMarkIcon size={20}
                                                                                       color={Styles.themeSecondaryColor.color}/>
                                                                        :
                                                                        item.prices ?
                                                                            <CCText
                                                                                className={'clickable'}
                                                                                style={{...Styles.themeColor}}
                                                                                onPress={async () => {
                                                                                    let dataCopy = [...data]
                                                                                    const index = dataCopy.findIndex(i => i.foo_id === item.foo_id)

                                                                                    dataCopy[index].toggling = true;
                                                                                    setData(dataCopy)

                                                                                    await handleItemSelect(item)

                                                                                    dataCopy = [...dataCopy]
                                                                                    dataCopy[index].toggling = false;
                                                                                    dataCopy[index].added = true;
                                                                                    setData(dataCopy)
                                                                                }}
                                                                            >
                                                                                {
                                                                                    item.prices.length > 1 ?
                                                                                        TMenuCategoryScreen[AppConfig.lang].ADD_ALL
                                                                                        :
                                                                                        TMenuCategoryScreen[AppConfig.lang].ADD
                                                                                }
                                                                            </CCText>
                                                                            :
                                                                            null
                                                            }
                                                        </View>
                                                        <CCText style={{
                                                            fontSize: 18,
                                                            color: '#777777',
                                                            whiteSpace: 'nowrap'
                                                        }}>
                                                            {
                                                                item.prices && item.prices.length === 1 ?
                                                                    MaskFunctions.maskMoney(item.prices[0].fpr_price) + ' ' + item.prices[0].fpr_currency
                                                                    :
                                                                    null
                                                            }
                                                        </CCText>
                                                        {
                                                            item.prices && item.prices.length > 1 ?
                                                                item.prices.map(p => <View
                                                                    key={p.fpr_id}
                                                                    style={{
                                                                        padding: '7px 25px',
                                                                        flexDirection: 'row',
                                                                        alignItems: 'center'
                                                                    }}
                                                                >
                                                                    <View>
                                                                        <CCText style={{fontSize: 18}}>
                                                                            {p.fpr_title}
                                                                        </CCText>
                                                                        <CCText style={{
                                                                            fontSize: 18,
                                                                            color: '#777777',
                                                                            whiteSpace: 'nowrap'
                                                                        }}>
                                                                            {MaskFunctions.maskMoney(p.fpr_price) + ' ' + p.fpr_currency}
                                                                        </CCText>
                                                                    </View>
                                                                    {
                                                                        <View
                                                                            style={{marginLeft: 15}}
                                                                        >
                                                                            {
                                                                                p.toggling ?
                                                                                    <ActivityIndicator/>
                                                                                    :
                                                                                    p.added || item.added ?
                                                                                        <CheckMarkIcon size={20}
                                                                                                       color={Styles.themeSecondaryColor.color}/>
                                                                                        :
                                                                                        <BorderlessButton
                                                                                            textStyle={{...Styles.themeColor}}
                                                                                            text={TMenuCategoryScreen[AppConfig.lang].ADD}
                                                                                            onPress={async (e) => {
                                                                                                if (e)
                                                                                                    e.stopPropagation();

                                                                                                let updatedData = [...data]
                                                                                                const foodIndex = updatedData.findIndex(i => i.foo_id === item.foo_id)

                                                                                                if (foodIndex === -1) {
                                                                                                    console.log('foodIndex: ' + foodIndex)
                                                                                                    return;
                                                                                                }

                                                                                                let prices = [...updatedData[foodIndex].prices];
                                                                                                const priceIndex = prices.findIndex(i => i.fpr_id === p.fpr_id)

                                                                                                if (priceIndex === -1) {
                                                                                                    console.log('priceIndex: ' + priceIndex)
                                                                                                    return
                                                                                                }

                                                                                                prices[priceIndex].toggling = true
                                                                                                updatedData[foodIndex].prices = prices;

                                                                                                setData(updatedData)

                                                                                                const json = await props.toggleMenuItem(prices[priceIndex], updatedData[foodIndex].foo_id);

                                                                                                if (json.success) {
                                                                                                    const updatedSection = {...props.menuSection}
                                                                                                    const updatedFood = [...updatedSection.food]
                                                                                                    const ind = updatedFood.findIndex(i => i.foo_id === updatedData[foodIndex].foo_id)

                                                                                                    if (ind === -1) {
                                                                                                        updatedFood.unshift({
                                                                                                            ...updatedData[foodIndex],
                                                                                                            prices: [
                                                                                                                {...prices[priceIndex]}
                                                                                                            ]
                                                                                                        })

                                                                                                        props.setTotalItems(1);
                                                                                                    } else {
                                                                                                        updatedFood[ind].prices.push({...prices[priceIndex]})
                                                                                                    }

                                                                                                    updatedSection.food = updatedFood;

                                                                                                    props.updateSection(updatedSection)


                                                                                                    // LOGIC TO UPDATE UI INSIDE THE SEARCH MODAL
                                                                                                    updatedData = [...data]
                                                                                                    prices = [...updatedData[foodIndex].prices]

                                                                                                    prices[priceIndex].toggling = false
                                                                                                    prices[priceIndex].added = true

                                                                                                    updatedData[foodIndex].prices = prices;

                                                                                                    setData(updatedData)
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                            }
                                                                        </View>
                                                                    }
                                                                </View>)
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>;
                                            })
                                            :
                                            <div></div>
                                    }
                                    {
                                        props.enableNewItemButton
                                            ?
                                            <View>
                                                <CCText style={{
                                                    fontSize: 20,
                                                    textAlign: 'center',
                                                    marginTop: 30,
                                                    marginBottom: 15
                                                }}>
                                                    {TMenuCategoryScreen[AppConfig.lang].OR_CREATE_FOOD}
                                                </CCText>
                                                <View style={{
                                                    flexDirection: 'row',
                                                    justifyContent: 'center',
                                                    padding: 15
                                                }}>
                                                    <DefaultButton
                                                        textStyle={{
                                                            fontSize: 20,
                                                            textAlign: 'center',
                                                        }}
                                                        onPress={() => {
                                                            if (props.onNewItemPressed)
                                                                props.onNewItemPressed(inputValue);
                                                        }}
                                                        text={TMenuCategoryScreen[AppConfig.lang].CREATE_AND_ADD + inputValue}
                                                    />
                                                </View>
                                            </View>
                                            :
                                            null
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
        }
    </Modal>;
};

const AddPricesModal = ({
                            visible,
                            onRequestClose,
                            food,
                            menuSection,
                            toggleMenuItem,
                            updateFood,
                            parentLoading = false
                        }) => {
    const auth = GetAuthObject();
    const [loading, setLoading] = useState<boolean>(false);
    const [isNewPriceOpen, setIsNewPriceOpen] = useState<boolean>(false);
    const [prices, setPrices] = useState<Array<FoodPrice>>([])


    useEffect(() => {
        if (!visible)
            return;

        setLoading(true);

        const f = async () => {
            const response = await fetch(AppConfig.URL + "/Menu/FetchSelectablePrices?FoodID=" + food.foo_id + '&MenuSectionID=' + menuSection.mse_id + '&ExcludeSelected=true', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                }
            });

            const json = await response.json();

            setPrices(json.prices);
            setLoading(false);
        }

        f()
    }, [visible])

    return <Modal
        visible={visible}
        onRequestClose={onRequestClose}
    >
        <h2>
            {TMenuCategoryScreen[AppConfig.lang].ADD_PRICES}
        </h2>
        <div style={{minHeight: 300}}>
            {(parentLoading || loading) ?
                <div style={{
                    height: 100,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <ActivityIndicator/>
                </div>
                :
                <div>
                    {
                        prices.length > 0 ?
                            prices.map(p => <View
                                key={p.fpr_id}
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    marginTop: 15,
                                    paddingTop: 15,
                                    borderTop: '1px solid #DDDDDD'
                                }}
                            >
                                <View>
                                    <CCText style={{fontSize: 18}}>
                                        {p.fpr_title}
                                    </CCText>
                                    <CCText style={{
                                        fontSize: 18,
                                        color: '#777777',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        {MaskFunctions.maskMoney(p.fpr_price) + ' ' + p.fpr_currency}
                                    </CCText>
                                </View>
                                {
                                    <View
                                        style={{marginLeft: 15}}
                                    >
                                        {
                                            p.toggling ?
                                                <ActivityIndicator/>
                                                :
                                                p.added ?
                                                    <CheckMarkIcon size={20}
                                                                   color={Styles.themeSecondaryColor.color}/>
                                                    :
                                                    <BorderlessButton
                                                        textStyle={{...Styles.themeColor}}
                                                        text={TMenuCategoryScreen[AppConfig.lang].ADD}
                                                        onPress={async (e) => {
                                                            if (e)
                                                                e.stopPropagation();

                                                            let updatedPrices = [...prices];
                                                            const priceIndex = updatedPrices.findIndex(i => i.fpr_id === p.fpr_id)

                                                            if (priceIndex === -1) {
                                                                console.log('priceIndex: ' + priceIndex)
                                                                return
                                                            }

                                                            updatedPrices[priceIndex].toggling = true

                                                            setPrices(updatedPrices)

                                                            const json = await toggleMenuItem(updatedPrices[priceIndex], food.foo_id);

                                                            if (json.success) {
                                                                const foodCopy = {...food}

                                                                updatedPrices[priceIndex].toggling = false

                                                                foodCopy.prices.push({...updatedPrices[priceIndex]})

                                                                updateFood(foodCopy)


                                                                // LOGIC TO UPDATE UI INSIDE THE SEARCH MODAL
                                                                updatedPrices = [...prices]

                                                                updatedPrices[priceIndex].toggling = false
                                                                updatedPrices[priceIndex].added = true

                                                                setPrices(updatedPrices)
                                                            }
                                                        }}
                                                    />
                                        }
                                    </View>
                                }
                            </View>)
                            :
                            <CCText style={{color: 'gray', padding: 15, textAlign: 'center', fontSize: 20}}>
                                {TMenuCategoryScreen[AppConfig.lang].NO_PRICES}
                            </CCText>
                    }
                    {
                        isNewPriceOpen ?
                            <FoodPricing
                                foodID={food.foo_id}
                                style={{marginTop: 15}}
                                editable={true}
                                onSuccess={async (price) => {
                                    setLoading(true)

                                    const foodCopy = {...food}

                                    await toggleMenuItem(price, foodCopy.foo_id)
                                    foodCopy.prices.push({...price})
                                    updateFood(foodCopy)

                                    setLoading(false)
                                    setIsNewPriceOpen(false)
                                    onRequestClose()
                                }}
                            />
                            :
                            <View
                                style={{flexDirection: 'row', justifyContent: 'center'}}
                            >
                                <DarkButton
                                    style={{marginTop: 15}}
                                    text={TMenuCategoryScreen[AppConfig.lang].NEW_PRICE}
                                    onPress={() => {
                                        setIsNewPriceOpen(!isNewPriceOpen)
                                    }}
                                />
                            </View>
                    }
                </div>
            }
        </div>
    </Modal>;
};